import { Injectable } from '@angular/core';
import { BaseDAO } from './baseDAO';
import { ConstantMan } from '../constantMan';
import { ApiHelper } from '../apiHelper';
import { Observable } from 'rxjs';

@Injectable()
export class ReportDAO extends BaseDAO<any> {
  constructor(public readonly apiHelper: ApiHelper) {
    super(apiHelper, ConstantMan.API.RESOURCE.REPORT);
  }

  getReports(): Observable<any> {
    const url = this.apiHelper.getServiceName() + 'reports/';
    const method = 'GET';
    const headers = this.apiHelper.getDefaultHeader();

    return this.apiHelper.apiCall(url, method, null, null, headers);
  }

  runReport(
    procedureName: string,
    fromDate: string,
    toDate: string,
  ): Observable<any> {
    const url = this.apiHelper.getServiceName() + 'reports/run/';
    const method = 'POST';
    const headers = this.apiHelper.getDefaultHeader();
    const body = {
      procedureName: procedureName,
      fromDate: fromDate,
      toDate: toDate,
    };

    return this.apiHelper.apiCall(url, method, null, body, headers);
  }
}
